import { combineReducers } from "redux";

// TODO: move reducers to sit with their associated components
// where appropriate
import { reducer as administeredUsers } from "@/components/administeredUsers/AdministeredUsers.state";
import { reducer as administeredUsersFilters } from "@/components/administeredUsers/FilterToolbar/FilterToolbar.state";
import { reducer as adminPage } from "@/components/adminPage";
import { reducer as customerSearch } from "@/components/customerSearchPage";
import { reducer as transactionSearchDatePicker } from "@/components/datePicker";
import { reducer as transactionSearchDatePickerV2Beta } from "@/components/datePickerV2Beta";
import { reducer as login } from "@/components/loginPage";
import { reducer as payment } from "@/components/payment";
import { reducer as profilePage } from "@/components/profilePage";
import { reducer as transactionSearch } from "@/components/transactionSearchPage";
import { reducer as transactionSearchV2Beta } from "@/components/transactionSearchPageV2Beta";
import { reducer as userSettingsPage } from "@/components/userSettingsPage";
import { header } from "@/reducers";

import alerts from "@/components/alerts/Alerts.state";
import agencies from "@/components/currentUser/Agencies.state";
import currentUser from "@/components/currentUser/CurrentUser.state";
import periscopeDashboard from "@/components/periscopeDashboard/PeriscopeDashboard.state";
import transactionSearchResults from "@/components/transactionSearchResults/TransactionSearchResults.state";
import transactionSearchResultsV2Beta from "@/components/transactionSearchResultsV2Beta/TransactionSearchResultsV2Beta.state";
import clientConfig from "@/state/client.state";
import okta from "@/state/okta/okta.state";
import sharedState from "@/state/shared.state";
import { posConfigToolState as posConfigTool } from "@revenue-management/pos-config-tool";

const appReducers = {
  header,
  okta,
  alerts,
  payment,
  login,
  currentUser,
  agencies,
  sharedState,
  administeredUsers,
  administeredUsersFilters,
  adminPage,
  userSettingsPage,
  profilePage,
  periscopeDashboard,
  customerSearch,
  transactionSearch,
  transactionSearchResults,
  transactionSearchDatePicker,
  transactionSearchV2Beta,
  transactionSearchResultsV2Beta,
  transactionSearchDatePickerV2Beta,
  clientConfig,
  posConfigTool,
};

export const RESET_APP_STATE = "global/RESET_APP_STATE";
export const resetAppState = () => ({ type: RESET_APP_STATE });

const createRootReducer = (state, action = {}) => {
  if (action.type === RESET_APP_STATE) {
    state = { config: state.config };
  }

  const appReducer = combineReducers({
    config: (state = null) => state,
    ...appReducers,
  });

  return appReducer(state, action);
};

export default createRootReducer;
